import ContentsTypes from "@shared/enums/contentsTypes";
import HomeTemplate from "@project/templates/home/HomeTemplate";
import contentsCustomTypesEnum from "@project/enums/contentsCustomTypes.enum";
import { createPricingCardItem } from "../pricingCardItem";
import { createDescriptionTabItem } from "../descriptionTabItem";
import { createColorImageBlock } from "../colorImageBlock";
import { createButton } from "../buttonWithArrow";
const createStatCardItem = (stat, statColor, title, description) => ({
    id: `stat-card-${stat}-${title}`,
    key: "items",
    type: contentsCustomTypesEnum.STAT_CARD,
    value: "",
    children: [
        {
            key: "stat",
            label: "Statistique",
            type: ContentsTypes.INPUT,
            value: stat,
        },
        {
            key: "statColor",
            label: "Couleur de la statistique",
            type: ContentsTypes.COLOR,
            value: statColor,
        },
        { key: "title", label: "Titre", type: ContentsTypes.INPUT, value: title },
        {
            key: "description",
            label: "Description",
            type: ContentsTypes.SHORT_TEXT,
            value: description,
        },
    ],
});
const createColumnWithIconItem = (title, description, icon = "check") => ({
    id: `column-with-icon-${title}`,
    key: "items",
    type: contentsCustomTypesEnum.COLUMN_WITH_ICON_ITEM,
    value: "",
    children: [
        {
            key: "icon",
            label: "Icône",
            type: ContentsTypes.ICON,
            value: "",
            children: [
                {
                    key: "icon",
                    type: ContentsTypes.INPUT,
                    value: icon,
                },
                {
                    key: "type",
                    type: ContentsTypes.INPUT,
                    value: "far",
                },
                {
                    key: "color",
                    type: ContentsTypes.COLOR,
                    value: "#0000FF",
                },
            ],
        },
        {
            key: "title",
            label: "Titre",
            type: ContentsTypes.INPUT,
            value: title,
        },
        {
            key: "description",
            label: "Description",
            type: ContentsTypes.INPUT,
            value: description,
        },
    ],
});
const createSolutionOrganisationItem = (label, title, question, description, url, buttonTitle, barColor) => ({
    key: "items",
    type: "SOLUTION_TYPE_ORGANISATION",
    value: "",
    children: [
        { key: "label", type: ContentsTypes.INPUT, value: label },
        { key: "title", type: ContentsTypes.INPUT, value: title },
        { key: "question", type: ContentsTypes.INPUT, value: question },
        { key: "description", type: ContentsTypes.SHORT_TEXT, value: description },
        {
            key: "buttonLink",
            type: ContentsTypes.LINK,
            value: "",
            children: [
                { key: "url", type: ContentsTypes.URL, value: url },
                { key: "page", type: "PAGE", value: "" },
                { key: "title", type: ContentsTypes.INPUT, value: buttonTitle },
                { key: "anchor", type: ContentsTypes.SELECT, value: "" },
                { key: "external", type: "CHECKBOX", value: "false" },
            ],
        },
        { key: "barColor", type: ContentsTypes.COLOR, value: barColor },
    ],
});
const createDescriptionServiceItem = (icon, title, description, component, iconColor = "#27272B", borderColor = "#AAAAB6") => ({
    key: "items",
    type: "DESCRIPTION_SERVICES_ITEM",
    value: "",
    children: [
        {
            key: "icon",
            type: ContentsTypes.ICON,
            value: "",
            children: [
                { key: "icon", type: ContentsTypes.INPUT, value: icon },
                { key: "type", type: ContentsTypes.SELECT, value: "custom" },
                { key: "color", type: ContentsTypes.COLOR, value: iconColor },
                { key: "background", value: "", type: "COLOR" },
            ],
        },
        { key: "borderColor", type: ContentsTypes.COLOR, value: borderColor },
        { key: "title", type: ContentsTypes.INPUT, value: title },
        { key: "description", type: ContentsTypes.INPUT, value: description },
        {
            key: "component",
            type: ContentsTypes.SELECT,
            value: component,
        },
    ],
});
const createDynamiquePartDescriptionTabItem = (imageId, imageName) => [
    {
        key: "dynamicElements",
        type: "IMAGE_BLOCK",
        value: "",
        children: [
            {
                key: "image",
                type: ContentsTypes.IMAGE,
                value: "",
                children: [
                    {
                        key: "file",
                        type: ContentsTypes.FILE_IMAGE,
                        value: JSON.stringify({
                            id: imageId,
                            name: imageName,
                            mimeType: "image/webp",
                            publicUrl: `/api/medias/${imageId}`,
                            url: `/api/medias/${imageId}`,
                            alt: "image",
                            title: "image",
                        }),
                    },
                    { key: "alt", type: ContentsTypes.INPUT, value: "image" },
                    { key: "title", type: ContentsTypes.INPUT, value: "image" },
                    {
                        key: "position_verticale",
                        type: ContentsTypes.SELECT,
                        value: "top",
                    },
                    {
                        key: "position_horizontale",
                        type: ContentsTypes.SELECT,
                        value: "center",
                    },
                    {
                        key: "position_ajustement",
                        type: ContentsTypes.SELECT,
                        value: "cover",
                    },
                ],
            },
            { key: "width", type: "SLIDER", value: "100" },
            { key: "mobileWidth", type: "SLIDER", value: "100" },
            { key: "justifyContent", type: "SELECT", value: "flex-start" },
        ],
    },
];
const createDarkServiceItem = (title, description) => ({
    key: "items",
    type: "DESCRIPTION_SERVICES_ITEM",
    value: "",
    children: [
        {
            key: "icon",
            type: ContentsTypes.ICON,
            value: "",
            children: [
                { key: "icon", type: ContentsTypes.INPUT, value: "" },
                { key: "type", type: ContentsTypes.SELECT, value: "far" },
                { key: "color", type: ContentsTypes.COLOR, value: "white" },
                { key: "background", type: ContentsTypes.COLOR, value: "" },
            ],
        },
        { key: "borderColor", type: ContentsTypes.COLOR, value: "#AAAAB6" },
        { key: "title", type: ContentsTypes.INPUT, value: title },
        { key: "description", type: ContentsTypes.INPUT, value: description },
        {
            key: "component",
            type: ContentsTypes.SELECT,
            value: "h3",
        },
    ],
});
const createWitnessCardItem = (name, job, imageId, imageName, iconColor, witnessText) => ({
    key: "items",
    type: "WITNESS_CARD",
    value: "",
    children: [
        { key: "title", type: ContentsTypes.INPUT, value: name },
        {
            key: "image",
            type: ContentsTypes.IMAGE,
            value: "",
            children: [
                {
                    key: "file",
                    type: ContentsTypes.FILE_IMAGE,
                    value: JSON.stringify({
                        sizes: [300, 600, 1000, 1400, 1600, 2000],
                        fileName: imageName,
                        fileType: "image/webp",
                        creator: "2b9a7946-f8db-4a71-96df-b5ed07452120",
                        id: imageId,
                        url: `/api/medias/${imageId}`,
                        alt: "image",
                        title: "image",
                    }),
                },
                { key: "alt", type: ContentsTypes.INPUT, value: "image" },
                { key: "title", type: ContentsTypes.INPUT, value: "image" },
                {
                    key: "position_verticale",
                    type: ContentsTypes.SELECT,
                    value: "top",
                },
                {
                    key: "position_horizontale",
                    type: ContentsTypes.SELECT,
                    value: "center",
                },
                {
                    key: "position_ajustement",
                    type: ContentsTypes.SELECT,
                    value: "cover",
                },
                {
                    key: "filters",
                    type: "IMAGE_FILTERS",
                    value: "",
                    children: [
                        { key: "activated", type: "CHECKBOX", value: "false" },
                        { key: "opacity", type: "SLIDER", value: "1" },
                        { key: "blur", type: "SLIDER", value: "0" },
                        { key: "grayscale", type: "SLIDER", value: "0" },
                        { key: "brightness", type: "SLIDER", value: "1" },
                        { key: "saturate", type: "SLIDER", value: "1" },
                        { key: "sepia", type: "SLIDER", value: "0" },
                    ],
                },
            ],
        },
        { key: "description", type: ContentsTypes.INPUT, value: job },
        { key: "iconColor", type: ContentsTypes.COLOR, value: iconColor },
        { key: "witness", type: ContentsTypes.SHORT_TEXT, value: witnessText },
    ],
});
const createAccordionPanelItem = (summary, textContent) => ({
    key: "panels",
    type: "ACCORDION_PANEL",
    value: "",
    children: [
        { key: "summary", type: ContentsTypes.INPUT, value: summary },
        { key: "iconColor", type: ContentsTypes.COLOR, value: "#282828" },
        {
            key: "details",
            type: "EXPANSION_PANEL_DETAILS",
            value: "",
            children: [
                {
                    key: "detailsElements",
                    type: "TEXT",
                    value: encodeURIComponent(`<p><span style="color:hsl(240,4%,32%);font-size:14px;">${textContent}</span></p>`),
                    children: [],
                },
            ],
        },
    ],
});
export const createRowButtonItem = (text, variant, iconName = "", iconColor = "white") => ({
    key: "items",
    type: "BUTTON",
    value: "",
    children: [
        { key: "text", type: ContentsTypes.INPUT, value: text },
        { key: "color", type: "BUTTON_GROUP", value: "primary" },
        { key: "variant", type: "BUTTON_GROUP", value: variant },
        { key: "size", type: "BUTTON_GROUP", value: "large" },
        { key: "fullWidth", type: "CHECKBOX", value: "false" },
        { key: "justifyContent", type: "BUTTON_GROUP", value: "center" },
        {
            key: "link",
            type: ContentsTypes.LINK,
            value: "",
            children: [
                { key: "url", type: ContentsTypes.URL, value: "" },
                { key: "page", type: "PAGE", value: "" },
                { key: "title", type: ContentsTypes.INPUT, value: "" },
                { key: "anchor", type: ContentsTypes.SELECT, value: "" },
                { key: "external", type: "CHECKBOX", value: "false" },
            ],
        },
        {
            key: "icon",
            type: ContentsTypes.ICON,
            value: "",
            children: [
                { key: "icon", type: ContentsTypes.INPUT, value: iconName },
                { key: "type", type: ContentsTypes.SELECT, value: "far" },
                { key: "color", type: ContentsTypes.COLOR, value: iconColor },
                { key: "background", type: ContentsTypes.COLOR, value: "" },
            ],
        },
    ],
});
export const createContactFormRowItem = (recipient, imageName, backgroundColor, iconName) => ({
    key: "dynamicElements",
    type: "ROW",
    value: "",
    children: [
        {
            key: "items",
            type: "CONTACT_FORM",
            value: "",
            children: [
                {
                    key: "recipient",
                    type: ContentsTypes.INPUT,
                    value: recipient || "",
                },
            ],
        },
        createColorImageBlock("256", "310", "760", imageName, backgroundColor, iconName, "#27272B"),
        { key: "justifyContent", type: ContentsTypes.SELECT, value: "flex-start" },
        { key: "spacing", type: "SLIDER", value: "50" },
        { key: "columnOnMobile", type: "CHECKBOX", value: "false" },
        { key: "useFlexWrap", type: "CHECKBOX", value: "false" },
    ],
});
export default {
    key: "HOME",
    label: "Accueil",
    shortDescription: "Pilotez simplement votre cybersécurité et garantissez la continuité de votre activité. TPE, PME, collectivité ou ETI : Docaposte identifie avec vous la protection adaptée à votre contexte.",
    templateImage: "/template-home.png",
    Component: HomeTemplate,
    initialContents: [
        {
            key: "title",
            type: ContentsTypes.TEXT,
            value: "%3Ch1%3E%3Cspan%20style%3D%22color%3Ahsl(0%2C%200%25%2C%20100%25)%3B%22%3EConcevons%20ensemble%20votre%20%3Cstrong%3Eprotection%20cyber%3C%2Fstrong%3E%20%C3%A0%20la%20mesure%20de%20vos%20enjeux%3C%2Fspan%3E%3C%2Fh1%3E",
        },
        {
            key: "shortDescription",
            type: ContentsTypes.TEXT,
            value: "%3Cp%20style%3D%22line-height%3A1.6%3B%22%3E%3Cspan%20style%3D%22color%3Ahsl(0%2C%200%25%2C%20100%25)%3Bfont-size%3A16px%3B%22%3EPilotez%20simplement%20votre%20cybers%C3%A9curit%C3%A9%20et%20garantissez%20la%20continuit%C3%A9%20de%20votre%20activit%C3%A9.%20TPE%2C%20PME%2C%20collectivit%C3%A9%20ou%20ETI%20%3A%20Docaposte%20identifie%20avec%20vous%20la%20protection%20adapt%C3%A9e%20%C3%A0%20votre%20contexte.%3C%2Fspan%3E%3C%2Fp%3E",
        },
        {
            key: "presentationDynamic",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                {
                    key: "dynamicElements",
                    type: "ROW",
                    value: "",
                    children: [
                        createRowButtonItem("Être rappelé par un expert", "contained"),
                        createRowButtonItem("Découvrir l'offre Cyber de Docaposte", "outlined"),
                        {
                            key: "justifyContent",
                            type: ContentsTypes.SELECT,
                            value: "flex-start",
                        },
                        { key: "spacing", type: "SLIDER", value: "24" },
                        { key: "columnOnMobile", type: "CHECKBOX", value: "true" },
                        { key: "useFlexWrap", type: "CHECKBOX", value: "true" },
                        {
                            key: "spacingMobile",
                            type: "SLIDER",
                            value: "16",
                        },
                    ],
                },
            ],
        },
        {
            key: "presentationTopBadge",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Votre solution cyber de proximité",
        },
        {
            key: "presentationBottomBadge",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Portée par le Groupe La Poste",
        },
        {
            key: "columnsWithIcon",
            type: contentsCustomTypesEnum.COLUMNS_WITH_ICON,
            value: "",
            children: [
                {
                    key: "dynamicList",
                    type: ContentsTypes.DYNAMIC_LIST,
                    value: "",
                    children: [
                        {
                            key: "contentType",
                            value: contentsCustomTypesEnum.COLUMN_WITH_ICON_ITEM,
                            children: [
                                createColumnWithIconItem("Simplicité", "une offre claire, lisible et accessible à tous"),
                                createColumnWithIconItem("Confiance", "La Poste & Docaposte, tiers de confiance de référence"),
                                createColumnWithIconItem("Flexibilité", "une protection qui évolue avec vos besoins"),
                            ],
                        },
                    ],
                },
            ],
        },
        {
            key: "titleSolutionsPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Des solutions flexibles",
        },
        {
            key: "subtitleSolutionsPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Des solutions Cyber adaptées à votre organisation",
        },
        {
            key: "descriptionSolutionsPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Votre besoin dépend de votre taille, de votre secteur d'activité, de vos priorités et de vos risques et enjeux. Docaposte vous aide à identifier l'approche la plus adaptée à votre contexte, avec une cybersécurité accessible, modulable et de confiance.",
        },
        {
            key: "dynamicSolutionsPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                {
                    key: "dynamicElements",
                    type: "COLUMN",
                    value: "",
                    children: [
                        createSolutionOrganisationItem("Vous êtes", "une TPE, petite PME et  petite collectivité", "Vous souhaitez sécuriser vos usages essentiels sans complexité ?", "Le Pack Cyber vous permet de démarrer simplement avec une protection claire, accompagnée et pilotable pour sécuriser vos postes, vos données et vos accès.", "/pack-cyber", "Découvrir le Pack Cyber", "#0CFFC6"),
                        createSolutionOrganisationItem("Vous êtes", "une PME, collectivité moyenne, organisation en croissance", "Vous souhaitez construire ou renforcer votre cybersécurité selon vos priorités ?", "Que votre dispositif cyber soit à construire ou à compléter, Docaposte vous aide à identifier les briques utiles, à ajuster le périmètre et à piloter les solutions retenues avec plus de lisibilité.", "/modules-outils", "Identifier les protections adaptées ", "#BF7CFF"),
                        createSolutionOrganisationItem("Vous êtes", "une ETI, grande collectivité, acteur public sensible ou organisation mature", "Vous avez des enjeux cyber avancés, ou des contraintes réglementaires ?", "Docaposte vous accompagne pour diagnostiquer, tester, renforcer, gouverner et mettre en conformité votre dispositif.", "/prestations-expertes", "Construire mon accompagnement cyber", "#FFFF80"),
                        { key: "alignItems", type: ContentsTypes.SELECT, value: "stretch" },
                        { key: "spacing", type: "SLIDER", value: "28" },
                        { key: "spacingMobile", type: "SLIDER", value: "20" },
                    ],
                },
            ],
        },
        {
            key: "titleThreatsPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Une menace en hausse",
        },
        {
            key: "subtitleThreatsPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Anticiper les risques cyber pour préserver la continuité d'activité",
        },
        {
            key: "descriptionThreatsPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Phishing, rançongiciel, mot de passe compromis, perte de données, faille applicative : les risques cyber prennent des formes multiples. Docaposte vous accompagne pour les couvrir par des actions claires, adaptées à votre contexte.",
        },
        {
            key: "dynamicThreatsStatsPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                {
                    key: "dynamicElements",
                    type: "GRID",
                    value: "",
                    children: [
                        createStatCardItem("1/3", "#BF7CFF", "des entreprises française", "ont subi une cyberattaque en 2025."),
                        createStatCardItem("38%", "#FFFF80", "des cyberattaques", "recensées en 2025 étaient du phishing."),
                        createStatCardItem("~ 80%", "#0CFFC6", "des TPE-PME", "reconnaissent ne pas être prêtes à faire face à une cyberattaque."),
                        createStatCardItem("14%", "#84AAFF", "seulement des collectivités", "se sentent réellement bien préparées à une cyberattaque."),
                        { key: "size", type: "SELECT_GRID", value: "3" },
                        { key: "sizeSm", type: "SELECT_GRID", value: "6" },
                        { key: "sizeXs", type: "SELECT_GRID", value: "12" },
                        { key: "justify", type: "SELECT", value: "flex-start" },
                        { key: "alignItems", type: "SELECT", value: "stretch" },
                        { key: "spacing", type: "SLIDER", value: "16" },
                        { key: "mobileSpacing", type: "SLIDER", value: "16" },
                    ],
                },
            ],
        },
        {
            key: "sourcesThreatsPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Sources : Baromètre de la cybersécurité des entreprises – CESIN 2025 · Baromètre de la maturité cyber 2025 – Cyblex/Docaposte",
        },
        {
            key: "dynamicThreatsPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                {
                    key: "dynamicElements",
                    type: "ROW",
                    value: "",
                    children: [
                        createRowButtonItem("Réaliser notre diagnostic de maturité pour évaluer votre couverture cyber", "outlined", "long-arrow-right"),
                        createRowButtonItem("Identifier les protections adaptées à mon organisation", "text", ""),
                        {
                            key: "justifyContent",
                            type: ContentsTypes.SELECT,
                            value: "flex-start",
                        },
                        { key: "spacing", type: "SLIDER", value: "20" },
                        { key: "columnOnMobile", type: "CHECKBOX", value: "true" },
                        { key: "useFlexWrap", type: "CHECKBOX", value: "true" },
                        {
                            key: "spacingMobile",
                            type: "SLIDER",
                            value: "16",
                        },
                    ],
                },
            ],
        },
        {
            key: "titleOffresPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Pack, modules & expertise",
        },
        {
            key: "subtitleOffresPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Une offre Cyber adaptée à votre organisation",
        },
        {
            key: "descriptionOffresPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Docaposte combine un Pack Cyber clair et lisible, des modules outils composables et des prestations expertes pour répondre à différents niveaux de besoin : protéger l’essentiel, renforcer une protection, structurer une trajectoire cyber avancée.",
        },
        {
            key: "dynamicOffresPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                {
                    key: "dynamicElements",
                    type: "GRID",
                    value: "",
                    children: [
                        createPricingCardItem("default", "L", "#0CFFC6", "Une cybersécurité pensée pour vous", "Protéger l'essentiel de votre environnement numérique", "Le Pack Cyber réunit les protections essentielles pour sécuriser votre environnement numérique au quotidien.", "<ul><li>Postes de travail & serveurs supervisés</li><li>Patrimoine de données sécurisé</li><li>Accès aux mots de passe centralisé</li></ul>", "Je bénéficie d'un pilotage simplifié grâce à un espace client dédié", "desktop", "false", "15,99 € HT / poste / mois", "Engagement 1 an · jusqu'à 20 postes · Frais d'installation : 490 € HT", "/pack-cyber", "Découvrir le Pack Cyber", ""),
                        createPricingCardItem("default", "L", "#BF7CFF", "Une cybersécurité adaptée à vous", "Renforcer votre protection cyber selon vos priorités", "Les modules outils permettent d'activer les protections adaptées selon vos risques prioritaires, votre organisation et le volume de postes à couvrir.", "<ul><li>Postes de travail & serveurs supervisés</li><li>Patrimoine de données sécurisé</li><li>Accès aux mots de passe centralisé</li><li>Protection de la messagerie</li><li>Filtrage de navigation</li><li>Protection des applications web&nbsp;</li></ul>", "Je bénéficie d'un pilotage simplifié grâce à un espace client dédié", "desktop", "true", "Sur devis", "Selon les modules retenus et votre volume de postes", "/modules-outils", "Découvrir nos modules outils", ""),
                        createPricingCardItem("default", "L", "#FFFF80", "Une cybersécurité guidée par nos experts", "Structurer votre trajectoire cyber", "Évaluez votre maturité cyber, priorisez vos actions, sécurisez vos projets, renforcez vos pratiques de gouvernance et mettez votre organisation en capacité de réagir face aux incidents.", "<ul><li>Qualification du besoin par un expert Docaposte</li></ul>", "", "", "false", "Sur devis", "Selon la stratégie cyber définie avec nos experts", "/prestations-expertes", "Découvrir nos prestations expertes", ""),
                        { key: "size", type: "SELECT_GRID", value: "4" },
                        { key: "sizeSm", type: "SELECT_GRID", value: "12" },
                        { key: "sizeXs", type: "SELECT_GRID", value: "12" },
                        { key: "justify", type: "SELECT", value: "center" },
                        { key: "alignItems", type: "SELECT", value: "stretch" },
                        { key: "spacing", type: "SLIDER", value: "40" },
                        { key: "mobileSpacing", type: "SLIDER", value: "24" },
                    ],
                },
            ],
        },
        {
            key: "titleLabelsPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Labels et certifications",
        },
        {
            key: "subtitleLabelsPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Une cybersécurité de confiance,\nofficiellement reconnue",
        },
        {
            key: "descriptionLabelsPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Docaposte associe son rôle de tiers de confiance à des solutions et partenaires reconnus, avec des certifications et labels qui renforcent la qualité, la souveraineté et la fiabilité de l’offre Cyber.",
        },
        {
            key: "dynamicLabelsPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                {
                    key: "dynamicElements",
                    type: "GRID",
                    value: "",
                    children: [
                        {
                            key: "items",
                            type: contentsCustomTypesEnum.CARD_LABEL,
                            value: "",
                            children: [
                                {
                                    key: "image",
                                    type: ContentsTypes.IMAGE,
                                    value: "",
                                    children: [
                                        {
                                            key: "file",
                                            type: ContentsTypes.FILE_IMAGE,
                                            value: JSON.stringify({
                                                url: "/api/medias/82df1188-65fc-4fcc-ab05-fc552a49c62f",
                                                alt: "image",
                                                title: "image",
                                            }),
                                        },
                                    ],
                                },
                                {
                                    key: "title",
                                    type: ContentsTypes.INPUT,
                                    value: "Label France Cybersecurity",
                                },
                                {
                                    key: "description",
                                    type: ContentsTypes.SHORT_TEXT,
                                    value: "Une reconnaissance de l'écosystème français de la cybersécurité.",
                                },
                                {
                                    key: "alignment",
                                    type: ContentsTypes.SELECT,
                                    value: "left",
                                },
                            ],
                        },
                        {
                            key: "items",
                            type: contentsCustomTypesEnum.CARD_LABEL,
                            value: "",
                            children: [
                                {
                                    key: "image",
                                    type: ContentsTypes.IMAGE,
                                    value: "",
                                    children: [
                                        {
                                            key: "file",
                                            type: ContentsTypes.FILE_IMAGE,
                                            value: JSON.stringify({
                                                url: "/api/medias/34d27483-b3c1-4934-b265-8e329390f73d",
                                                alt: "image",
                                                title: "image",
                                            }),
                                        },
                                    ],
                                },
                                {
                                    key: "title",
                                    type: ContentsTypes.INPUT,
                                    value: "Coup de cœur Alliancy 2025",
                                },
                                {
                                    key: "description",
                                    type: ContentsTypes.SHORT_TEXT,
                                    value: "Une distinction qui valorise la pertinence de l'offre Cyber Docaposte.",
                                },
                                {
                                    key: "alignment",
                                    type: ContentsTypes.SELECT,
                                    value: "left",
                                },
                            ],
                        },
                        {
                            key: "items",
                            type: contentsCustomTypesEnum.CARD_LABEL,
                            value: "",
                            children: [
                                {
                                    key: "image",
                                    type: ContentsTypes.IMAGE,
                                    value: "",
                                    children: [
                                        {
                                            key: "file",
                                            type: ContentsTypes.FILE_IMAGE,
                                            value: JSON.stringify({
                                                url: "/api/medias/93619193-d514-475f-8f0f-fa1c1ad32238",
                                                alt: "image",
                                                title: "image",
                                            }),
                                        },
                                    ],
                                },
                                {
                                    key: "title",
                                    type: ContentsTypes.INPUT,
                                    value: "Premier EDR partenaire certifié et qualifié ANSSI",
                                },
                                {
                                    key: "description",
                                    type: ContentsTypes.SHORT_TEXT,
                                    value: "Une technologie reconnue par les autorités française.",
                                },
                                {
                                    key: "alignment",
                                    type: ContentsTypes.SELECT,
                                    value: "",
                                },
                            ],
                        },
                        {
                            key: "items",
                            type: contentsCustomTypesEnum.CARD_LABEL,
                            value: "",
                            children: [
                                {
                                    key: "image",
                                    type: ContentsTypes.IMAGE,
                                    value: "",
                                    children: [
                                        {
                                            key: "file",
                                            type: ContentsTypes.FILE_IMAGE,
                                            value: JSON.stringify({
                                                url: "/api/medias/fffadf3b-efb7-4cca-91bd-0c74e603be83",
                                                alt: "image",
                                                title: "image",
                                            }),
                                        },
                                    ],
                                },
                                {
                                    key: "title",
                                    type: ContentsTypes.INPUT,
                                    value: "Seul EDR avec double certification",
                                },
                                {
                                    key: "description",
                                    type: ContentsTypes.SHORT_TEXT,
                                    value: "Le seul EDR disposant d'une double certification ANSSI et BSI.",
                                },
                                {
                                    key: "alignment",
                                    type: ContentsTypes.SELECT,
                                    value: "left",
                                },
                            ],
                        },
                        { key: "size", type: "SELECT_GRID", value: "3" },
                        { key: "sizeSm", type: "SELECT_GRID", value: "12" },
                        { key: "sizeXs", type: "SELECT_GRID", value: "12" },
                        { key: "justify", type: "SELECT", value: "flex-start" },
                        { key: "alignItems", type: "SELECT", value: "stretch" },
                        { key: "spacing", type: "SLIDER", value: "16" },
                        { key: "mobileSpacing", type: "SLIDER", value: "16" },
                    ],
                },
            ],
        },
        {
            key: "titleInterfacePart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Interface unifiée",
        },
        {
            key: "subtitleInterfacePart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "L'Espace client : votre centre de contrôle cyber",
        },
        {
            key: "descriptionInterfacePart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Centralisez votre sécurité (protection étendue, sauvegarde sécurisée, gestionnaire de mot de passe) et optimisez votre gestion opérationnelle.",
        },
        {
            key: "dynamicInterfacePart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                {
                    key: "dynamicElements",
                    type: "DESCRIPTION_TABS",
                    value: "",
                    children: [
                        { key: "direction", type: "RADIO_GROUP", value: "vertical" },
                        { key: "style", type: "RADIO_GROUP", value: "text" },
                        { key: "color", type: "RADIO_GROUP", value: "primary" },
                        {
                            key: "dynamicList",
                            type: ContentsTypes.DYNAMIC_LIST,
                            value: "",
                            children: [
                                {
                                    key: "contentType",
                                    value: "DESCRIPTION_TABS_ITEM",
                                    children: [
                                        createDescriptionTabItem("L'essentiel, en un coup d'œil", "Votre dashboard intuitif regroupant agents installés, volumétrie sécurisée et gravité des incidents détectés en temps réel.", "false", "", "#0000FF", createDynamiquePartDescriptionTabItem("", "")),
                                        createDescriptionTabItem("Simplification opérationnelle", "Accédez au pilotage unifié de vos solutions (sauvegarde sécurisée, gestionnaire de MDP) et à une synthèse claire des actions prioritaires pour gagner en efficacité.", "false", "", "#0000FF", createDynamiquePartDescriptionTabItem("", "")),
                                        createDescriptionTabItem("Proximité et support direct", "Ouvrez vos tickets d’incident, échangez sur les dossiers en cours et contactez-nous directement depuis votre espace client.", "false", "", "#0000FF", createDynamiquePartDescriptionTabItem("", "")),
                                    ],
                                },
                            ],
                        },
                    ],
                },
                {
                    key: "dynamicElements",
                    type: "DESCRIPTION_SERVICE_CARD",
                    value: "",
                    children: [
                        { key: "size", type: ContentsTypes.SELECT, value: "M" },
                        { key: "isDark", type: "CHECKBOX", value: "false" },
                        {
                            key: "title",
                            type: ContentsTypes.INPUT,
                            value: "Services associes",
                        },
                        {
                            key: "component",
                            type: ContentsTypes.SELECT,
                            value: "h3",
                        },
                        { key: "spacing", type: "SLIDER", value: "48" },
                        { key: "mobileSpacing", type: "SLIDER", value: "24" },
                        {
                            key: "dynamicList",
                            type: ContentsTypes.DYNAMIC_LIST,
                            value: "",
                            children: [
                                {
                                    key: "contentType",
                                    value: "DESCRIPTION_SERVICES_ITEM",
                                    children: [
                                        createDescriptionServiceItem("automatisation", "Support au deploiement", "Une assistance technique pour installer et configurer vos outils de cybersecurite rapidement et sans erreur.", "p"),
                                        createDescriptionServiceItem("service_client", "Support telephonique et visio", "Une assistance technique disponible pour repondre a vos questions et resoudre vos problemes.", "p"),
                                        createDescriptionServiceItem("livre_blanc", "Ressources pedagogiques", "Videos, tutoriels et FAQ pour vous aider a utiliser vos outils en toute autonomie.", "p"),
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            key: "titleCyberPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Pourquoi la solution cyber docaposte",
        },
        {
            key: "subtitleCyberPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Vos bénéfices au quotidien",
        },
        {
            key: "descriptionCyberPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Une cybersécurité claire, modulable et accompagnée pour protéger votre organisation sans complexité inutile.",
        },
        {
            key: "dynamicCyberPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                {
                    key: "dynamicElements",
                    type: "DESCRIPTION_SERVICE_CARD",
                    value: "",
                    children: [
                        { key: "size", type: ContentsTypes.SELECT, value: "L" },
                        { key: "isDark", type: "CHECKBOX", value: "false" },
                        { key: "title", type: ContentsTypes.INPUT, value: "" },
                        { key: "spacing", type: ContentsTypes.SLIDER, value: "48" },
                        { key: "mobileSpacing", type: ContentsTypes.SLIDER, value: "16" },
                        {
                            key: "component",
                            type: ContentsTypes.SELECT,
                            value: "h3",
                        },
                        {
                            key: "dynamicList",
                            type: ContentsTypes.DYNAMIC_LIST,
                            value: "",
                            children: [
                                {
                                    key: "contentType",
                                    value: "DESCRIPTION_SERVICES_ITEM",
                                    children: [
                                        createDescriptionServiceItem("offre_sur_mesure", "Une offre sur mesure qui évolue avec vous", "Des protections adaptées à vos besoins réels, activables progressivement, sans suréquipement inutile.", "h3", "#0000FF", "#27272B"),
                                        createDescriptionServiceItem("relation_collaborateur", "Une cybersécurité accessible et accompagnée", "Un discours clair, un accompagnement de proximité et des ressources pour avancer sans être expert cyber.", "h3", "#0000FF", "#27272B"),
                                        createDescriptionServiceItem("ordinateur", "Un pilotage tout-en-un pour simplifier le quotidien", "Un espace client pour suivre vos solutions, accéder au support et piloter facilement votre cybersécurité.", "h3", "#0000FF", "#27272B"),
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            key: "titleMaturityPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: ` Où en êtes-vous ? Faites le diagnostic de maturité cyber`,
        },
        {
            key: "subtitleMaturityPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Évaluez votre niveau d'exposition et recevez des recommandations \nadaptées à votre structure.",
        },
        {
            key: "dynamicMaturityPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                createButton("Commencez le diagnostic de maturité cyber", "/pack-cyber"),
                {
                    key: "dynamicElements",
                    type: "DESCRIPTION_SERVICE_CARD",
                    value: "",
                    children: [
                        { key: "size", type: ContentsTypes.SELECT, value: "S" },
                        { key: "isDark", type: "CHECKBOX", value: "true" },
                        { key: "title", type: ContentsTypes.INPUT, value: "" },
                        { key: "spacing", type: "SLIDER", value: "40" },
                        { key: "mobileSpacing", type: "SLIDER", value: "20" },
                        {
                            key: "component",
                            type: ContentsTypes.SELECT,
                            value: "p",
                        },
                        {
                            key: "dynamicList",
                            type: ContentsTypes.DYNAMIC_LIST,
                            value: "",
                            children: [
                                {
                                    key: "contentType",
                                    value: "DESCRIPTION_SERVICES_ITEM",
                                    children: [
                                        createDarkServiceItem("~ 2 minutes ", "Un questionnaire pensé pour être court"),
                                        createDarkServiceItem("5 questions ciblées", "Sur vos usages, vos accès et vos outils"),
                                        createDarkServiceItem("Recommandations concrètes", "Selon les enjeux et la taille de votre structure"),
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            key: "titleWitnessPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Nos témoignages clients",
        },
        {
            key: "subtitleWitnessPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Ils ont choisi de sécuriser leur écosystème numérique avec Docaposte",
        },
        {
            key: "descriptionWitnessPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Des collectivités font appel à Docaposte pour renforcer leur cybersécurité avec une approche claire, accompagnée et adaptée à leur niveau de maturité.",
        },
        {
            key: "dynamicWitnessPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                {
                    key: "dynamicElements",
                    type: "GRID",
                    value: "",
                    children: [
                        createWitnessCardItem("Élise Brigand", "Directrice des usages  numériques · Eure Normandie Numérique", "", "10978307925ad11bfafacf3308e35808dc5775ec.webp", "#BF7CFF", "Eure Normandie Numérique accompagne les collectivités dans leurs usages numériques et a retenu Docaposte comme partenaire cyber. La collaboration est valorisée pour sa proximité, la simplicité des échanges et sa capacité à répondre aux besoins de sécurisation des communes adhérentes."),
                        createWitnessCardItem("Francine Bacher", "Maire · Marcilly-la-Campagne", "", "8979d5a30423e379e281fb0879702ac52797ee2c.webp", "#50e3c2", "La commune souligne la qualité d'écoute des interlocuteurs Docaposte et la capacité à proposer des solutions adaptées à ses besoins. Le témoignage rappelle que même les petites communes doivent renforcer leur sécurité pour préserver leurs systèmes et protéger les données des administrés."),
                        createWitnessCardItem("Coralie Bouscharain", "Responsable informatique · Commune de Thue et Mue", "", "ccd8679a742409863fe69a4124f3ede597084b56.webp", "#84AAFF", "Après un premier audit ayant identifié des failles, la commune de Thue et Mue a retenu plusieurs services Docaposte : analyse, protection des postes, gestionnaire de mots de passe et sensibilisation au phishing."),
                        { key: "size", type: "SELECT_GRID", value: "4" },
                        { key: "sizeSm", type: "SELECT_GRID", value: "12" },
                        { key: "sizeXs", type: "SELECT_GRID", value: "12" },
                        { key: "justify", type: "SELECT", value: "center" },
                        { key: "alignItems", type: "SELECT", value: "stretch" },
                        { key: "spacing", type: "SLIDER", value: "32" },
                        { key: "mobileSpacing", type: "SLIDER", value: "24" },
                    ],
                },
            ],
        },
        {
            key: "titleFAQPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Questions fréquemment posées",
        },
        {
            key: "dynamicFAQPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                {
                    key: "dynamicElements",
                    type: "ACCORDION",
                    value: "",
                    children: [
                        createAccordionPanelItem("Quelle est la différence entre le Pack Cyber et les modules outils ?", "Le Pack Cyber est une offre clé en main qui regroupe l'ensemble des briques essentielles de cybersécurité en un seul abonnement simplifié. Les modules outils, eux, sont des solutions individuelles que vous pouvez activer à la carte selon vos besoins spécifiques."),
                        createAccordionPanelItem("Combien de temps prend la mise en service ?", "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras condimentum vehicula lorem id feugiat. Maecenas sit amet dapibus odio. Cras magna erat, faucibus id tortor et, lacinia auctor eros. Aenean non elementum lacus. Praesent viverra vehicula nisl, sit amet sollicitudin velit ullamcorper quis. "),
                        createAccordionPanelItem("Comment se déroule le déploiement sur mes postes de travail ?", "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras condimentum vehicula lorem id feugiat. Maecenas sit amet dapibus odio. Cras magna erat, faucibus id tortor et, lacinia auctor eros. Aenean non elementum lacus. Praesent viverra vehicula nisl, sit amet sollicitudin velit ullamcorper quis. "),
                        createAccordionPanelItem("Puis-je ajouter ou retirer des postes en cours de contrat ?", "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras condimentum vehicula lorem id feugiat. Maecenas sit amet dapibus odio. Cras magna erat, faucibus id tortor et, lacinia auctor eros. Aenean non elementum lacus. Praesent viverra vehicula nisl, sit amet sollicitudin velit ullamcorper quis. "),
                        createAccordionPanelItem("Le Pack Cyber est-il compatible avec Windows, macOS et Linux ?", "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras condimentum vehicula lorem id feugiat. Maecenas sit amet dapibus odio. Cras magna erat, faucibus id tortor et, lacinia auctor eros. Aenean non elementum lacus. Praesent viverra vehicula nisl, sit amet sollicitudin velit ullamcorper quis. "),
                        createAccordionPanelItem("Puis-je gérer plusieurs sites ou entités depuis un seul espace client ?", "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras condimentum vehicula lorem id feugiat. Maecenas sit amet dapibus odio. Cras magna erat, faucibus id tortor et, lacinia auctor eros. Aenean non elementum lacus. Praesent viverra vehicula nisl, sit amet sollicitudin velit ullamcorper quis. "),
                        createAccordionPanelItem("Comment puis-je accéder à mon espace client ?", "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras condimentum vehicula lorem id feugiat. Maecenas sit amet dapibus odio. Cras magna erat, faucibus id tortor et, lacinia auctor eros. Aenean non elementum lacus. Praesent viverra vehicula nisl, sit amet sollicitudin velit ullamcorper quis. "),
                    ],
                },
            ],
        },
        {
            key: "titleFurtherPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Aller plus loin",
        },
        {
            key: "subtitleFurtherPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Poursuivez votre parcours selon votre besoin",
        },
        {
            key: "dynamicFurtherPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                {
                    key: "dynamicElements",
                    type: "GRID",
                    value: "",
                    children: [
                        createPricingCardItem("default", "M", "#0CFFC6", "TPE, petite PME, petite collectivités", "Découvrir le pack cyber", "Pour les petites structures qui souhaitent une offre packagée, lisible et accompagnée pour protéger l’essentiel.", "", "", "", "", "", "", "/pack-cyber", "Découvrir", "long-arrow-right"),
                        createPricingCardItem("default", "M", "#BF7CFF", "PME, collectivités moyenne", "Explorer les modules outils", "Pour compléter votre protection avec des modules adaptés à vos risques prioritaires.", "", "", "", "", "", "", "/modules-outils", "Découvrir", "long-arrow-right"),
                        createPricingCardItem("default", "M", "#FFFF80", "ETI, grande collectivités, organisation mature", "Découvrir les prestations expertes", "Pour compléter votre protection avec un accompagnement expert sur mesure.", "", "", "", "", "", "", "/prestation-expertes", "Découvrir", "long-arrow-right"),
                        { key: "size", type: "SELECT_GRID", value: "4" },
                        { key: "sizeSm", type: "SELECT_GRID", value: "12" },
                        { key: "sizeXs", type: "SELECT_GRID", value: "12" },
                        { key: "justify", type: "SELECT", value: "center" },
                        { key: "alignItems", type: "SELECT", value: "stretch" },
                        { key: "spacing", type: "SLIDER", value: "48" },
                        { key: "mobileSpacing", type: "SLIDER", value: "16" },
                    ],
                },
            ],
        },
        {
            key: "titleContactPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Comment pouvons-nous vous accompagner ?",
        },
        {
            key: "subtitleContactPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Être rappelé par un expert Docaposte",
        },
        {
            key: "descriptionContactPart",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Vous souhaitez en savoir plus sur l'offre Cyber de Docaposte ou savoir si nous répondons aux défis et aux besoins de votre structure ? Dans ce cas, merci de remplir notre formulaire et nous vous contacterons dans les 48 h.",
        },
        {
            key: "dynamicContactPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                createContactFormRowItem("", "1ae615a1e4c1d21896795aaa42a8a079b17ed688.webp", "#FFFF80", "dialoguer"),
            ],
        },
    ],
};
